/**
 * ブラウザ側の計装（アプリが操作できるようになる前に 1 回だけ走る・Next の規約ファイル）。
 *
 * - 画面のエラーを拾ってエラーダイアログに出し、FE サーバーのログへ送る（`lib/errors/pipeline.ts`・#456）
 * - 画面の表示を FE サーバーのログへ送る（最初の表示と、画面遷移の開始ごと・#459）。検索欄の入力などで
 *   URL が続けて変わるときは落ち着いてから 1 回だけ送る
 */
import { postClientLog } from "@/lib/errors/client-log";
import { installErrorReporting } from "@/lib/errors/pipeline";

/** URL が続けて変わるとき、最後の変化からこの時間おいて 1 回だけ送る。 */
const PAGE_VIEW_SETTLE_MS = 1_000;

let lastSentPage: string | null = null;
let pendingTimer: ReturnType<typeof setTimeout> | undefined;

function schedulePageView(page: string): void {
  clearTimeout(pendingTimer);
  pendingTimer = setTimeout(() => {
    if (page === lastSentPage) return;
    lastSentPage = page;
    postClientLog({ type: "page_view", page, occurred_at: new Date().toISOString() });
  }, PAGE_VIEW_SETTLE_MS);
}

function pageOf(url: string): string {
  const parsed = new URL(url, window.location.href);
  return `${parsed.pathname}${parsed.search}`;
}

try {
  installErrorReporting();
  schedulePageView(pageOf(window.location.href));
} catch {
  // 計装の失敗で画面を止めない
}

/**
 * 画面遷移の開始ごとに、遷移先の表示をログへ送る（Next が呼ぶ）。
 *
 * @param url - 遷移先の URL。
 */
export function onRouterTransitionStart(url: string): void {
  try {
    schedulePageView(pageOf(url));
  } catch {
    // 計装の失敗で画面を止めない
  }
}
